<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text">Manage Marketing Divisions</h3>
  <div>
    <button (click)="addMarketDivision()" color="primary" class="action-button"
            id="delete-button"
            mat-raised-button>
      Add
    </button>
  </div>
</div>
<!-- Display message if there is no data -->
<div [hidden]="!noData">No current marketing divisions</div>

<div [hidden]="noData" class="gfs-table" id="mainTableDiv">

  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="marketDivisions"
    [columnDefs]="columnDef"
    [autoSizeStrategy]="autoSizeStrategy"
  />
</div>
